import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDocumentResponse } from '../models/document.model';
import { AuthService } from './auth.service';
import { IFormFieldsRequest, IFormStructure } from '../models/form.interface';
import { ITemplate } from '../models/template.model';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/templates';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }


  list(tagsList: string[] = [], moduleId: string, isModelPatient: boolean = false): Promise<Array<IDocumentResponse>> {
    return new Promise((resolve, reject) => {

      var tags = tagsList.join(',');
      const url = `${this.baseUrl}?tags=${tags}&module=${moduleId}&is_model_patient=${isModelPatient}`;
      this.http.get<Array<IDocumentResponse>>(url)
        .subscribe({
          next: (response) => {
            resolve(response);
          },
          error: (err) => {
            reject(err?.error);
          }
        });
    })
  }

  getTemplateById(id: string): Promise<ITemplate> {
    return new Promise((resolve, reject) => {
      this.http.get<ITemplate>(`${this.baseUrl}/${id}`)
        .subscribe({
          next: (response) => {
            resolve(response);
          },
          error: (err) => {
            reject(err?.error);
          }
        });
    });
  }

  listPaged(pageNumber: number, pageSize: number, orderBy: string, sortBy: string, search: string = '') {
    const params: any = {
      pageNumber,
      pageSize,
      orderBy,
      sortBy
    };

    if (search && search.trim() !== '') {
      params.search = search;
    }

    return this.http.get<any>(`${this.baseUrl}/paged`, {
      params
    });
  }

  deleteTemplate(id: string) {
    return this.http.delete<any>(`${this.baseUrl}/${id}`);
  }

  updateTemplate(id: string, document: any, template?: File, modules: string = "") {

    const formData: FormData = new FormData();
    document.fields.forEach((field: IFormStructure) => {
      formData.append('fields', field.id);
    });

    formData.append('name', document.name);
    formData.append('template_type', document.template_type);
    formData.append('modules', modules);
    if (template)
      formData.append('template', template);
    return this.http.put<any>(`${this.baseUrl}/${id}`, formData);
  }

  createTemplate(document: ITemplate, template?: File) {

    const formData: FormData = new FormData();
    document.fields?.forEach((field: IFormStructure, index) => {
      formData.append('fields', field.id);
    });

    formData.append('name', document.name);
    formData.append('template_type', document.template_type || 'OTHER');
    formData.append('modules', document.modules?.map(module => module.id).join(',') || '');
    if (template)
      formData.append('template', template);
    return this.http.post<any>(`${this.baseUrl}`, formData);
  }

  getFilledControls(selectedValue: string | Array<string>, control: IFormStructure): Promise<Array<IFormStructure>> {
      var newValueArray: Array<string> = [];
  
      if (Array.isArray(selectedValue)) {
        selectedValue.forEach((value, index) => {
          let newValue = value.replace(',', '%2C');
          newValue = newValue.replace('/', '%SLASH%');
          newValueArray[index] = newValue;
        });
      }
      var selectedValueFinal = Array.isArray(selectedValue) ? newValueArray.join(',') : selectedValue;
      var selectedValueFinalAsUrl = encodeURIComponent(selectedValueFinal);
      return new Promise((resolve, reject) => {
        this.http.get<Array<IFormStructure>>(`${this.baseUrl}/fields/${control.id}/${selectedValueFinalAsUrl}`)
          .subscribe({
            next: resolve,
            error: (err) => {
              reject(err?.error);
            }
          });
      });
    }

  fields(request: IFormFieldsRequest, anamneseId: string, patientId: string): Promise<Array<IFormStructure>> {
      let param = new HttpParams().set('document_ids', request.document_ids.join(','));
      if (anamneseId) {
        param = param.append('anamnese_id', anamneseId);
      }
      if (patientId) {
        param = param.append('patient_id', patientId);
      }
  
      return new Promise((resolve, reject) => {
        this.http.get<Array<IFormStructure>>(`${this.baseUrl}/fields`, { params: param })
          .subscribe({
            next: resolve,
            error: (err) => {
              reject(err?.error);
            }
          });
      })
    }
  
    listAllFields(): Promise<Array<IFormStructure>> {
      return new Promise((resolve, reject) => {
        this.http.get<Array<IFormStructure>>(`${this.baseUrl}/fields/all`)
          .subscribe({
            next: resolve,
            error: (err) => {
              reject(err?.error);
            }
          });
      });
    }
}
